import { Link } from '@tanstack/react-router'
import { Smartphone } from 'lucide-react'
import { useCurrentBusiness } from '~/entities/business/model/use-business'
import { PROFILE_LINK_ANCHOR } from '~/entities/profile-link/model/profile-link-anchor'
import { useProfileLinks } from '~/entities/profile-link/model/use-profile-links'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { Card, CardContent } from '~/shared/ui/card'

/** Points to "Pulsify-Profil verbinden" so requests can be answered from the app. */
export function ProfileLinkPrompt() {
  const { data: business } = useCurrentBusiness()
  const links = useProfileLinks(business?.id ?? '')
  const count = links.data?.links.length ?? 0

  return (
    <Card>
      <CardContent className="flex flex-col items-start gap-3 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p className="flex items-start gap-2 text-sm text-muted-foreground">
          <Smartphone className="mt-0.5 size-4 shrink-0" />
          {count > 0
            ? m.profileLinkPromptConnected({ count: String(count) })
            : m.profileLinkPrompt()}
        </p>
        <Button asChild variant="outline" size="sm">
          <Link to="/dashboard/settings" hash={PROFILE_LINK_ANCHOR}>
            {count > 0 ? m.profileLinkManage() : m.profileLinkTitle()}
          </Link>
        </Button>
      </CardContent>
    </Card>
  )
}
